import React, { Fragment, useEffect, useState } from "react";
import CategoryHome from "../components/CategoryHome";
import Download from "../components/Download";
// import FlashSale from "../components/FlashSale";
import Services from "../components/Services";
import TopBuyToday from "../components/home/TopBuyToday";
import TopSellToday from "../components/home/TopSellToday";
import SellingProducts from "../components/SellingProducts";
import ProductsWithin from "../components/ProductsWithin";
import APIService from "../services/APIService";
import TopBanner from "../components/home/TopBanner";
import MidBanner from "../components/home/MidBanner";
import BottomBanner from "../components/home/BottomBanner";
import { selectModalCart, setModalCart } from "../app/features/cart";

export default function HomePage() {
  const [banner, setBanner] = useState({})

  async function getListBanner(from) {
    const RESULT = await APIService.getListBanner(from);
    if (RESULT) {
      setBanner(RESULT);
    }
  }

  useEffect(() => {
    getListBanner();
  }, []);

  return (
    <div>
      <TopBanner data={banner.banners} />
      <div className="h-8"/>
      {/* <FlashSale></FlashSale> */}
      <div className="h-8"/>
      <CategoryHome></CategoryHome>
      <div className="h-8"/>
      <MidBanner data={banner.qc_middle} />
      <div className="h-8"/>
      <SellingProducts />
     
      <ProductsWithin />
      <div className="h-8"/>
      <div className="flex  sm:flex-row flex-col gap-x-[30px]">
        <div className="flex flex-1">
          <TopBuyToday />
        </div>
        <div className="flex flex-1 mt-6 sm:mt-0">
          <TopSellToday />
        </div>
      </div>
      <div className="h-8"/>
      <BottomBanner data={banner.qc_bottom}/>
    </div>
  );
}
